import { checkSectionEmptiness } from 'portfolio3/features/pdf/utils/checkSectionEmptiness';
import { createSelector } from 'reselect';
import { profileInterestsSelector } from 'selectors';

export const profileEmptyDataMapSelector = createSelector([profileInterestsSelector], (profileInterests) => {
  const emptyDataMap = {
    interests: profileInterests.content.length === 0,
  };
  return {
    ...emptyDataMap,
    profile: checkSectionEmptiness(emptyDataMap),
  };
});
